import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, Renderer2} from '@angular/core';
import { ModalService } from '../../service/modal/modal.service';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalBasicComponent  {
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Output() onContainerClickedModal = new EventEmitter();
  public visible = false;
  public visibleAnimate = false;

  constructor(private renderer: Renderer2, private modalService: ModalService) {}


  public show(): void {
    this.modalService.incrementOpenModalCount();
    this.visible = true;
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.modalService.decrementOpenModalCount()
    this.visibleAnimate = false;
    if (this.modalService.getOpenModalCount() === 0){
      this.renderer.setStyle(document.body, 'overflow', 'auto');
    }
    setTimeout(() => this.visible = false, 300);
  }


}
